import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Badge, Card, Icon, Dropdown, Grid} from 'tabler-react';
import { withRouter, NavLink } from 'react-router-dom';

const propTypes = {
    user: PropTypes.object.isRequired
};

const UserCard = ({user}) => {

    const fullAddress = () => {
        const address = user.address;
        let str = address.street;

        if(address.complement !== '') str += `, ${address.complement}`;
        if(address.district !== '') str += `, ${address.district}`;

        return str;
    };

    return (
        <Card>
            <Card.Body>
                <div className="row align-items-center">
                    <div className="col-auto">
                        <Avatar size="xl" color="green">{user.initials}</Avatar>
                    </div>
                    <div className="col">
                        <h4 className="m-0">{user.name}</h4>
                        <Badge color="primary" className="mr-1">
                            {user.isMinor === 'YES' ? 'Artista Mirim' : 'Artista Adulto'}
                        </Badge>

                        <Badge color={user.activated === "ACTIVATED" ? 'success' : 'secondary'} className="mr-1">
                            {user.activated === "ACTIVATED" ? 'Ativo' : 'Desativado'}
                        </Badge>
                    </div>
                    <div className="col-auto">
                        {/*<Dropdown*/}
                        {/*    type="button"*/}
                        {/*    arrow={true}*/}
                        {/*    triggerContent=" "*/}
                        {/*    className="user-dropdown-edit"*/}
                        {/*    position="bottom-end"*/}
                        {/*    arrowPosition="right"*/}
                        {/*    itemsObject={[{*/}
                        {/*        icon: 'edit',*/}
                        {/*        value: "Atualizar Informações",*/}
                        {/*        to: '/edit',*/}
                        {/*        LinkComponent: withRouter(NavLink)*/}
                        {/*    }]}*/}

                        {/*/>*/}
                    </div>
                </div>
            </Card.Body>
            {
                // container com dados do assinante mirim
                user.isMinor === 'YES' &&
                <Card.Body>
                    <h4>Dados do Responsável Legal</h4>
                    <Grid.Row>
                        <Grid.Col width={12}>
                            <h6 className="mb-0">Nome do Responsável</h6>
                            <p>{user.guardian.fullName}</p>
                        </Grid.Col>
                    </Grid.Row>
                    <Grid.Row>

                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Col width={6}>
                            <h6 className="mb-0">Telefone</h6>
                            <p>{user.phone}</p>
                        </Grid.Col>

                        <Grid.Col width={6}>
                            <h6 className="mb-0">Data de Nascimento</h6>
                            <p>{user.guardian.birthday}</p>
                        </Grid.Col>

                        <Grid.Col width={6}>
                            <h6 className="mb-0">E-mail</h6>
                            <p>{user.email}</p>
                        </Grid.Col>

                        <Grid.Col width={6}>
                            <h6 className="mb-0">CPF</h6>
                            <p>{user.document}</p>
                        </Grid.Col>
                    </Grid.Row>
                </Card.Body>
            }

            {
                // Container com dados do assinante adulto
                user.isMinor === 'NO' &&
                <Card.Body>
                    <Grid.Row>
                        <Grid.Col width={12}>
                            <h6 className="mb-0">E-mail</h6>
                            <p>{user.email}</p>
                        </Grid.Col>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Col width={6}>
                            <h6 className="mb-0">Telefone</h6>
                            <p>{user.phone}</p>
                        </Grid.Col>

                        <Grid.Col width={6}>
                            <h6 className="mb-0">CPF</h6>
                            <p>{user.document}</p>
                        </Grid.Col>
                    </Grid.Row>
                </Card.Body>
            }

            <Card.Body>
                <Grid.Row>
                    <Grid.Col width={12}>
                        <h6 className="mb-0">Endereço</h6>
                        <p dangerouslySetInnerHTML={{__html: fullAddress()}}/>
                    </Grid.Col>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Col width={6}>
                        <h6 className="mb-0">CEP</h6>
                        <p>{user.address.zipCode}</p>
                    </Grid.Col>

                    <Grid.Col width={6}>
                        <h6 className="mb-0">Local</h6>
                        <p>
                            {user.address.city}{', '}
                            {user.address.state}
                        </p>
                    </Grid.Col>
                </Grid.Row>
            </Card.Body>
        </Card>
    );
};

UserCard.propTypes = propTypes;

export default UserCard;